"use client";
import { theme as e, DEFAULT_PRIMARY_BRAND_COLOR as s } from "@inkeep/cxkit-theme";
const a = {
  model: "inkeep-qa-expert",
  placeholder: "How do I get started?",
  aiAssistantName: void 0,
  shouldOpenLinksInNewTab: !0,
  disclaimerSettings: {
    isEnabled: !1,
    label: "Usage policy"
  },
  isShareButtonVisible: !1,
  isViewOnly: !1,
  exampleQuestionsLabel: "Example questions",
  exampleQuestions: [],
  isFirstExampleQuestionHighlighted: !0,
  isCopyChatButtonVisible: !1,
  getHelpOptions: [],
  workflowsHeader: "Workflows",
  workflows: [],
  toolbarButtonLabels: {
    clear: "Clear",
    share: "Share",
    getHelp: "Get help",
    stop: "Stop",
    copyChat: "Copy"
  },
  prompts: []
}, l = {
  env: "production",
  apiKey: "",
  aiApiBaseUrl: "https://api.inkeep.com",
  analyticsApiBaseUrl: "https://api.io.inkeep.com",
  shouldBypassCaptcha: !1,
  privacyPreferences: {
    optOutAnalyticalCookies: !1,
    // disable use of cookies for analytics. Default is false.
    optOutAllAnalytics: !1,
    // disable all event logging, even analytics that don't use cookies (e.g. anonymous events)
    optOutFunctionalCookies: !1
    // disable all cookies that are used for functionality, like caching chat sessions cross-tabs. Default is false.
  },
  tags: [],
  userProperties: {},
  primaryBrandColor: s,
  theme: {
    varsClassName: "inkeep-widget-vars",
    ...e
  }
}, i = {
  shouldOpenLinksInNewTab: !1,
  maxResults: 40,
  defaultQuery: "",
  debounceTimeMs: 0,
  tabs: ["All", "Publications", "PDFs", "GitHub", "Forums", "Discord", "Slack", "StackOverflow"],
  placeholder: "Search for anything...",
  view: "single-pane"
};
export {
  a as defaultInkeepAIChatSettings,
  l as defaultInkeepBaseSettings,
  i as defaultInkeepSearchSettings
};
